"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useActions", {
  enumerable: true,
  get: function () {
    return _useActions.useActions;
  }
});
exports.useAnalysis = exports.useDispatch = exports.useState = exports.AnalysisProvider = exports.initialState = void 0;

var _react = require("react");

var _reducer = require("./reducer");

var _factory = require("../factory");

var _useActions = require("./useActions");

/**
 * The initial state of analysis context
 */
const initialState = {
  viewMode: 'monitoring'
};
exports.initialState = initialState;
const stateContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const dispatchContext = /*#__PURE__*/(0, _react.createContext)(undefined);
/**
 * Define a context around Analysis components.
 * The context is intended to be used on shared stuff between insights and monitoring views.
 * e.g. monitoring view can have different datagrid columns or toolbar compared to insights view.
 * This help us to render approrpriate underlying components.
 */

const AnalysisProvider = (0, _factory.createProvider)(stateContext, dispatchContext, _reducer.reducer, initialState);
exports.AnalysisProvider = AnalysisProvider;
const useState = (0, _factory.createStateHook)(stateContext);
exports.useState = useState;
const useDispatch = (0, _factory.createDispatchHook)(dispatchContext);
exports.useDispatch = useDispatch;
const useAnalysis = (0, _factory.createContextHook)(stateContext, dispatchContext);
exports.useAnalysis = useAnalysis;